import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Paper, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import WorkIcon from "@mui/icons-material/Work";

function WorkActivitiesComponent() {
  const location = useLocation();
  const isPublicResultRoute = location.pathname.includes("/public-result");

  // Get data from appropriate reducer based on route
  const publicResult = useSelector((state) => state?.ResultReducer?.publicResult || {});
  const previousResult = useSelector(
    (state) => state?.ResultReducer?.previousResult?.userData || {},
  );

  // Determine which data source to use
  const resultData = isPublicResultRoute
    ? publicResult?.userData || publicResult || {}
    : previousResult;

  const [userData, setUserData] = useState({
    workActivities: [],
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    // Get workActivities from the appropriate source
    const workActivitiesData = isPublicResultRoute
      ? publicResult?.userData?.workActivities || publicResult?.workActivities || []
      : resultData?.workActivities || [];

    if (Array.isArray(workActivitiesData) && workActivitiesData.length > 0) {
      setUserData({ workActivities: workActivitiesData });
    } else {
      setUserData({ workActivities: [] });
    }
    setLoading(false);
  }, [resultData, publicResult, isPublicResultRoute]);
  return (
    <>
      <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
        <Grid item xs={12}>
          {userData?.workActivities?.length > 0 && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  border: "1px solid #8DE49A",
                  borderRadius: "20px",
                  p: { xs: 3, sm: 3, md: 3, lg: 3 },
                  minWidth: { xs: "100%", md: "100%", lg: "70%" },
                  maxWidth: {
                    xs: "100%",
                    md: "100%",
                    lg: userData?.workActivities?.length === 0 ? "100%" : "70%",
                  },
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      mb: "32px",
                    }}
                  >
                    <div
                      style={{
                        width: "51px",
                        height: "51px",
                        backgroundColor: "#2bb344",
                        color: "#ffffff",
                        borderRadius: "30%",
                      }}
                    >
                      <WorkIcon
                        sx={{
                          width: { xs: "40px", md: "100%" },
                          height: "40px",
                          maxWidth: "51px",
                          alignSelf: "center",
                          marginTop: "5px",
                        }}
                        alt="WorkIcon"
                      />
                    </div>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 600,
                        pl: { xs: 1, lg: 2 },
                        textAlign: "center",
                      }}
                    >
                      Work Activities
                    </Typography>
                  </Box>

                  {loading ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        py: 2,
                      }}
                    >
                      <CircularProgress color="primary" size={30} />
                    </Box>
                  ) : (
                    <Grid
                      container
                      sx={{
                        gap: 2,
                        justifyContent: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {userData?.workActivities?.map((activity, index) => (
                        <Grid item key={index}>
                          <Paper
                            sx={{
                              border: "1px solid #8DE49A",
                              borderRadius: "15px",
                              display: "flex",
                              boxShadow: "none",
                              alignItems: "center",
                              px: 2,
                              py: 1,
                              maxWidth: "500px",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "16px",
                                  md: "20px",
                                  lg: "20px",
                                },
                                textAlign: "center",
                              }}
                            >
                              {activity}
                            </Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Box>
          )}
        </Grid>
      </Box>
    </>
  );
}

export default WorkActivitiesComponent;
